import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaPlus, FaCalendarCheck } from 'react-icons/fa';

export default function TopBar() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-100">
      <div className="flex items-center gap-4">
        <h1 className="text-base font-bold text-brand-secondary">Dashboard</h1>
        <Link
          to="/admin/week-management"
          className="hidden lg:flex items-center gap-1 text-[11px] text-gray-400 hover:text-brand-primary transition-colors"
        >
          <FaCalendarCheck className="text-[10px]" />
          Week Management
        </Link>
      </div>
      <div className="hidden lg:flex items-center gap-2">
        <button
          onClick={() => navigate('/job-cards/list')}
          className="flex items-center gap-1.5 bg-brand-primary text-white text-xs font-semibold px-3 py-1.5 rounded-lg hover:opacity-90 transition-opacity"
        >
          <FaPlus className="text-[9px]" /> Job Card
        </button>
        <button
          onClick={() => navigate('/expenses/new')}
          className="flex items-center gap-1.5 border border-gray-200 text-gray-600 text-xs font-semibold px-3 py-1.5 rounded-lg hover:border-brand-primary hover:text-brand-primary transition-colors"
        >
          <FaPlus className="text-[9px]" /> Expense
        </button>
      </div>
    </div>
  );
}
